import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';

export interface UserSessionDto {
  id: string;
  userId: string;
  username: string;
  fullName: string;
  ipAddress?: string | null;
  userAgent?: string | null;
  deviceInfo?: string | null;
  loginDate: string;
  lastActivityDate: string;
  expiresAt: string;
  isCurrentSession: boolean;
}

export interface SessionFilterDto {
  userId?: string;
  page?: number;
  pageSize?: number;
}

export const sessionApi = {
  /** GET /api/v1/sessions — list of active sessions for the company */
  getList: (filter?: SessionFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<UserSessionDto>>>('/sessions', {
      params: filter,
    }),

  /** DELETE /api/v1/sessions/{id} — terminate a specific session */
  terminate: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/sessions/${id}`),

  /** DELETE /api/v1/sessions/user/{userId} — terminate all sessions for a user */
  terminateAllForUser: (userId: string) =>
    apiClient.delete<ApiResponse<object>>(`/sessions/user/${userId}`),
};
